import Axios from "axios";
import Config from "../config/app.js";
import { getToken } from "@/utils/app.js";
import { Toast } from "vant";
import { isAndroid, isClient } from "@/utils/isTerminal.js";
import { loginInvalid } from "@/utils/JSBridge.js";
import { VersionVerification } from "@/utils/versionCompare.js";
import { dataGather } from "@/utils/aLiLogTracking";

const service = Axios.create({
  baseURL: Config.apiUrl + "/" + Config.apiPrefix,
  headers: {
    Accept: "*/*",
  },
  timeout: Config.timeout,
});

service.defaults.retry = Config.requestRetry;
service.defaults.retryDelay = Config.requestRetryDelay;

let LoadingInstance = null;

service.interceptors.request.use(
  (config) => {
    if (!config.closeLoading) {
      // console.log('123');
      LoadingInstance = Toast.loading({
        mask: true,
        duration: 0,
        message: "加载中...",
      });
    }
    config.headers["businessSource"] = 1;
    config.headers["terminalPlatform"] = isAndroid ? 3 : 2;
    config.headers["requestId"] = new Date().getTime();
    config.headers["Authorization"] = getToken() || "";

    if (VersionVerification("5.4.6")) {
      //App版本大于等于5.4.6 .保持和App内部一致，否则token不能共用
      config.headers["loginType"] = "APP";
    }
    // config.headers["Authorization"] =
    //   "eyJhbGciOiJIUzI1NiIsIlR5cGUiOiJKd3QiLCJ0eXAiOiJKV1QifQ.eyJsb2dpbklkIjoiMzM2YjgzMDk0NTlmNGFlMmExYWM0NGM1MTg4ZTk3NGUiLCJsb2dpblRpbWUiOiIyMDI1LTEyLTI0IDIzOjI3OjU0IiwiZXhwIjoxMzA2MTU2MDg4OTQsInVzZXJJZCI6IjQyNzY4MDg3MTc2OTYwODE5MiJ9.vZpyHqk059T9T_N81S6ta2_B2vEsnnEd0Pm1XybxYl8";
    // config.headers["loginType"] = "APP";

    if (config.noToken) {
      config.headers["Authorization"] = "";
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (res) => {
    if (LoadingInstance) {
      LoadingInstance.clear();
    }

    if (res.status !== 200) {
      Toast("数据返回出错");
      return Promise.reject("error");
    } else {
      if (res.data.code === 200111) {
        dataGather("ERROR-110", "ERROR-110-200111");
      }
      if (res.data.code === 100004) {
        //登录状态失效
        loginInvalid();
        sessionStorage.removeItem("userNurseLoginInfo");
        return;
      }
      if (res.data.code !== 100000) {
        if (res.config.closeInterceptors) {
          return Promise.reject(res.data); //微信code被重复使用走这里
        }
        Toast(res.data.msg);
        return Promise.reject(res.data.msg);
      }
      return res.data.data;
    }
  },
  (error) => {
    const { code } = error;
    if (LoadingInstance) {
      LoadingInstance.clear();
    }

    if ("ECONNABORTED" == code) {
      Toast("请求超时，请重试");
      return Promise.reject("请求超时，请重试");
    }

    if (error.config.closeNetworkError) {
      return Promise.reject("网络错误");
    } else {
      Toast("网络错误");
      return Promise.reject("网络错误");
    }
  }
);

export default service;
